<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="iconSize"
    :height="iconSize"
    :class="{ lrg: isNotAdmin }"
    viewBox="0 0 34 34"
  >
    <g transform="translate(-15 -397)">
      <circle
        cx="17"
        cy="17"
        r="17"
        transform="translate(15 397)"
        :fill="color"
      />
      <g transform="translate(-71.209 49.791)">
        <circle cx="3" cy="3" r="3" transform="translate(96.209 357.209)" fill="#383935" />
        <circle cx="3" cy="3" r="3" transform="translate(104.209 357.209)" fill="#383935" />
        <circle cx="3" cy="3" r="3" transform="translate(96.209 365.209)" fill="#383935" />
        <circle cx="3" cy="3" r="3" transform="translate(104.209 365.209)" fill="#383935" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CoursesIcon',
  props: {
    color: {
      type: String,
      default: 'rgb(165, 216, 103)', // fallback
    }
  },
  computed: {
    isNotAdmin() {
      const nonAdminRoutes = ['/', 'Home', 'Login', 'License', 'Welcome', 'Unit'];
      return nonAdminRoutes.includes(this.$route.name) || this.$route.path === '/';
    },
    iconSize() {
      return this.isNotAdmin ? '38' : '34';
    }
  }
}
</script>

<style scoped>
svg {
  width: 34px;
  height: 34px;
}
svg.lrg {
  width: 38px;
  height: 38px;
}
</style>
